import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const ROUTES = {
  CONTACT_ROLE_LIST: 'organization-contact-role'
}

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const routes = [
  {
    path: 'contact-role/',
    name: ROUTES.CONTACT_ROLE_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['organization_contactrole_list'],
      requiresAuth: true
    },
    component: () => import('./ContactRoleList.vue')
  }

]

export { routes, ROUTES }
